<template>
  <div id="app">
    <el-container v-if="isShow">
      <div v-if="!isCollapse" class="aside-btn aside-btn-pos" @click="isCollapse=true">
        <i class="el-icon-d-arrow-left"></i>
      </div>
      <el-aside class="aside" :width="isCollapse?'65px':'180px'">
        <div class="menu-box">
          <div v-if="isCollapse" class="aside-btn" @click="isCollapse=false">
            <i class="el-icon-d-arrow-right"></i>
          </div>
          <div v-if="!isCollapse" class="logo-box">
            <img src="./assets/image/logo.png" alt="">
            <!-- <span>{{INFO.company_name?INFO.company_name:INFO.nickname?INFO.nickname:INFO.username?INFO.username:''}}</span> -->
          </div>
          <left-menu :isShowMenu="isCollapse" ref="leftMenu"></left-menu>
        </div>
      </el-aside>
      <el-container>
        <el-header class="header">
          <top-header></top-header>
        </el-header>
        <el-main>
          <!-- main -->
          <transition name="fade" appear mode="out-in">
            <div class="main-box">
              <div class="page-title">当前位置：{{PAGE_TITLE}}</div>
              <!-- <keep-alive> -->
                <router-view/>
              <!-- </keep-alive> -->
            </div>
          </transition>
        </el-main>
      </el-container>
    </el-container>
    <keep-alive>
     <router-view v-if="!isShow"></router-view>
    </keep-alive>
  </div>
</template>

<script>
import { 
  Container,
  Header,
  Aside,
  Main,
  Footer
} from 'element-ui'
import { leftMenu, topHeader } from '@/components'
import {
  mapActions,
  mapGetters,
  mapMutations
} from 'vuex';
export default {
  name: 'App',
  data(){
    return{
      isCollapse:false,
      isShow:true
    }
  },
  methods:{
    ...mapActions('user',[
      'LOGIN',
    ]),
    ...mapMutations('user',[
      'SET_TOKEN',
      'SET_REFRESH_TOKEN',
      'SET_ACCESS_TOKEN'
    ]),
    isFull(){
      let urls = ['login'];
      for(let i = 0,len = urls.length;i<len;i++){
          if(urls[i] == this.$route.name) return false
      }
      return true
    }
  },
  created () {
    let token = localStorage.getItem('token');
    let refresh_token = localStorage.getItem('refresh_token');
    let access_token = localStorage.getItem('access_token');
    if( token && refresh_token && access_token ){
      this.SET_TOKEN(token);
      this.SET_REFRESH_TOKEN(refresh_token);
      this.SET_ACCESS_TOKEN(access_token);
    }
    // let userInfo =localStorage.getItem('u');
    // if( userInfo ){
    //   userInfo = JSON.parse(userInfo);
    //   this.LOGIN({
    //     username:userInfo.n,
    //     password:userInfo.p
    //   }).then(dt=>{
    //     this.$refs.leftMenu.getMenuList();
    //   })
    // }else{
    //   this.$router.replace({name:'login'})
    // }

    //在页面加载时读取sessionStorage里的状态信息
    // if (sessionStorage.getItem("store") ) {
    //   this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(sessionStorage.getItem("store"))))
    // } 

    //在页面刷新时将vuex里的信息保存到sessionStorage里
    // window.addEventListener("beforeunload",()=>{
    //   sessionStorage.setItem("store",JSON.stringify(this.$store.state))
    // })
  },
  mounted(){  },
  computed:{
    ...mapGetters('user',['INFO']),
    ...mapGetters([
      'PAGE_TITLE'
    ])
  },
  watch:{
    $route(c,b){
      this.isShow = this.isFull();
    }
  },
  components:{
    leftMenu,
    topHeader,
    elContainer:Container,
    elAside:Aside,
    elHeader:Header,
    elMain:Main,
    elFooter:Footer
  }
}
</script>

<style scoped>
.aside-btn-pos{
  position: absolute;
  z-index: 1;
  top: 0;
  left: 179px;
  border-left: 1px solid #e6e6e6;
}
.aside-btn{
  display: block;
  height: 59px;
  line-height: 59px;
  width: 64px;
  text-align: center;
  border-radius: 3px;
  font-size: 20px;
  background: #fff;
  border-right: 1px solid #e6e6e6;
  color: #409EFF;
}
.logo-box{
    height: 40px;
    padding: 10px 20px;
    display: flex;
    align-items: center;
    color: #555;
    font-size: 19px;
    border-right: 1px solid #e6e6e6;
}
.logo-box img{
  /* max-height: 27px;
  margin-right: 20px; */
  max-height: 30px;
}

.header{
  border-bottom: 1px solid #e6e6e6;
}

.page-title{
  color: #999;
  margin-bottom: 10px;
}

.menu-box{
  position: fixed;
}
</style>
<style>
.el-main{
  padding: 10px 20px;
  height: calc(100vh - 60px);
  background: #fff;
  /* overflow: hidden; */
}

</style>



// WEBPACK FOOTER //
// src/App.vue